const debug = false;
import countyZipRegexMap from '../config/zip-country-regexp';

var getZipCodeRegex = function (countryCode) {
    // TODO: handle missing countryCode
    return countyZipRegexMap[countryCode];
};

var updateZipCodePattern = function (form) {
    var currentCountryCode = $('body').data('country');
    var formCountry = form.find('[name$="_addressFields_country"], [name$="_address_country"]').val();
    var countryCode = formCountry || currentCountryCode;
    var zipRegex =  getZipCodeRegex(countryCode);
    debug && console.log(`Set new pattern to ${zipRegex}`);
    form.find('[name$="_addressFields_postalCode"], [name$="_address_postalCode"], [name$="_addressFields_shipToStoreAccessPointsZipCode"]').attr('pattern', zipRegex);
};

module.exports = {
    updateZipCodePattern: updateZipCodePattern
};


// WEBPACK FOOTER //
// ./assets/scripts/util/postalCodePattern.js